import React, { useCallback, ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import FieldSelect from '../field-select/field-select.component';
import FormatService from '../../services/format-service';
import useStylesFilterSelectField from './filter-select-field.styles';
import { FILTER_VALUE_EMPTY } from '../../constants/system/filter-values';

const FilterSelectField: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const ID_PREFIX_FILTER_SELECT_FIELD: string = 'filter-select-field';
  const LABEL_PREFIX: string = 'Filter by';

  const {
    isInteger,
    filterType,
    label,
    value,
    menuItemList,
    currentFilters,
    onSetFilterValue,
  } = props;

  const { classes } = useStylesFilterSelectField();

  const fieldId: string = filterType ? `${ID_PREFIX_FILTER_SELECT_FIELD}-${filterType}` : ID_PREFIX_FILTER_SELECT_FIELD;

  const onChange: Function = useCallback((event: EventSelectChange, value: string): void => {
    if (onSetFilterValue) {
      onSetFilterValue(filterType, isInteger ? FormatService.parseInt(value) : value);
    }
  }, [filterType, isInteger, currentFilters]);

  return (
    <FlexContainer isCentered className={classes.filterSelectField}>
      <FieldSelect
        isPlain
        isOutlined
        withBlankElement
        withBlankItemDefault
        value={value}
        blankElementValue={FILTER_VALUE_EMPTY}
        blankElementLabel={`${LABEL_PREFIX} ${label}`}
        label={label}
        id={fieldId}
        onChange={onChange}
      >
        {menuItemList}
      </FieldSelect>
    </FlexContainer>
  );
});

export default FilterSelectField;
